import { RefObject, useEffect, useRef } from 'react';
import usePrevValue from './usePrevValue';

const useElementRefCallbackOn = <T extends HTMLElement>(
  condition: boolean,
  callback: (element: T) => void,
  callbackOnInit: boolean = true, // Whether to run callback on initial render
): RefObject<T> => {
  const ref = useRef<T>(null);
  const prevCondition = usePrevValue(condition);

  useEffect(() => {
    if (prevCondition === undefined && !callbackOnInit) {
      return;
    }

    if (ref.current && condition && prevCondition !== condition) {
      callback(ref.current);
    }
  }, [condition, prevCondition, ref, callback, callbackOnInit]);

  return ref;
};

export default useElementRefCallbackOn;
